import axios from 'axios'

const state = {
  user: null,
  token: null,
  records: null
}

const getters = {
  StateDNSRecords: state => state.records,
}

const actions = {
  async CreateDNSRecord ({ dispatch }, record) {
    return axios
      .post('dns/records', record)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetDNSRecords', record.domain_id)
      })
  },
  async GetDNSRecords ({ commit }, domain_id) {
    return axios
    .get('dns/records', {params: {domain_id: domain_id }})
      .then(response => {
        commit('setRecords', response.data)
        return response.data
      })
      .catch(error => { throw(error) })
      .finally(() => {
        //dispatch('GetDNSRecords', record.domain_id)
      })
    
  },
  async UpdateDNSRecord ({ dispatch }, record) {
    return axios
      .put('dns/records/' + record.id, record)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetDNSRecords', record.domain_id)
      })
  },
  async DeleteDNSRecord ({ dispatch }, record) {
    return axios
      .delete('dns/records/' + record.id)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
        dispatch('GetDNSRecords', record.domain_id)
      })
  }
}

const mutations = {
  setRecords (state, records) {
    state.records = records
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}
